import { navbar_notification_browser_methods } from './navbar_notification_browser_methods';
import { navbar_notification_data_methods } from './navbar_notification_data_methods';
import { navbar_notification_action_methods } from './navbar_notification_action_methods';

export const navbar_notification_methods = {
  ...navbar_notification_browser_methods,
  ...navbar_notification_data_methods,
  ...navbar_notification_action_methods,
};
